// extracted by mini-css-extract-plugin
export default {"code":"TerminalImage_code__TGmAZ","gif":"TerminalImage_gif__qE1Wj"};